import script from "./ConfirmAbord.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmAbord.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmAbord.vue?vue&type=style&index=0&id=b515fe5a&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b515fe5a"]])

export default __exports__